module.exports = __webpack_public_path__ + "img/bg-icon4.571125f1.png";